import React, { useState } from 'react';
import {
  Drawer,
  Box,
  Button,
  Paper
} from '@mui/material';
import PropTypes from 'prop-types';
import { useTitanConfig } from './hooks/useTitanConfig';
import { GameDetailsContent } from './components/GameDetailsContent';
import { TitanConfigView } from './components/TitanConfigView';
import '../../Styles/Components/GameDetailsDrawer.css';

const GameDetailsDrawer = ({ game, selectedGame, matchedGameData, open, onClose, singleGameData }) => {
  const [activeTab, setActiveTab] = useState(0);
  const { titanConfigData, errorMessage } = useTitanConfig(activeTab, selectedGame);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      className="game-details-drawer"
      PaperProps={{
        className: "drawer-paper",
        elevation: 0
      }}
    >
      <Box className="drawer-container">
        <Paper className="tabs-container">
          <Box className="tabs-wrapper">
            <Button
              className={`tab-button ${activeTab === 0 ? 'active' : ''}`}
              onClick={() => setActiveTab(0)}
            >
              Game Details
            </Button>
            <Button
              className={`tab-button ${activeTab === 1 ? 'active' : ''}`}
              onClick={() => setActiveTab(1)}
            >
              Titan Config
            </Button>
          </Box>
        </Paper>

        <Box className="content-section">
          {activeTab === 0 ? (
            <GameDetailsContent
              game={game}
              selectedGame={selectedGame}
              matchedGameData={matchedGameData}
              singleGameData={singleGameData}
            />
          ) : (
            <TitanConfigView
              titanConfigData={titanConfigData}
              errorMessage={errorMessage}
            />
          )}
        </Box>
      </Box>
    </Drawer>
  );
};

GameDetailsDrawer.propTypes = {
  game: PropTypes.object,
  selectedGame: PropTypes.object,
  matchedGameData: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  singleGameData: PropTypes.bool,
};

export default GameDetailsDrawer;